// MUI base styles
import colors from "../base/colors";
import borders from "../base/borders";

// MUI helper functions
import pxToRem from "../functions/pxToRem";

const {white,sidenavigation,black} = colors;
const {borderRadius} = borders;

const sidenav = {
    styleOverrides: {
        root: {
            width: pxToRem(256),
            whiteSpace: "nowrap",
            border: "none",
            fontFamily: '"Raleway", sans-serif',
            fontWeight: 400,
            fontStyle: 'normal',
            backgroundColor:sidenavigation.main

        },

        paper: {
            width: pxToRem(256),
            backgroundColor: black.main,
            height: "100vh",
            // margin: `${pxToRem(16)} 0 ${pxToRem(16)} ${pxToRem(16)}`,
            // borderRadius: borderRadius.xl,
            border: "none",
        },

        paperAnchorDockedLeft: {
            borderRight: "none",
        },
    },
};

export default sidenav;
